import { render, staticRenderFns } from "./SalaryView.vue?vue&type=template&id=5b5e8b3c&"
import script from "./SalaryView.vue?vue&type=script&lang=ts&"
export * from "./SalaryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports